import React from 'react';
import { motion } from 'framer-motion';
import { Edit3, Link, UploadCloud, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { FunnelDiagram } from '../components/FunnelDiagram';
interface OrientationScreenProps {
  onNext: () => void;
  onBack?: () => void;
}
export function OrientationScreen({
  onNext,
  onBack
}: OrientationScreenProps) {
  return <div className="min-h-screen flex flex-col items-center justify-center p-6 pb-20 bg-[#0f0f2d]" data-id="element-113">
      <div className="max-w-4xl w-full text-center" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="mb-12" data-id="element-115">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-116">
            How funnels work
          </h2>
          <p className="text-xl text-[#8b8bab] max-w-2xl mx-auto" data-id="element-117">
            Funnels are made up of steps. Each step has a specific purpose to
            guide your visitor.
          </p>
        </motion.div>

        <div className="mb-16" data-id="element-118">
          <FunnelDiagram data-id="element-119" />
        </div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.5,
        duration: 0.8
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16 max-w-3xl mx-auto" data-id="element-120">
          <div className="flex flex-col items-center" data-id="element-121">
            <div className="w-12 h-12 rounded-full bg-[#1a1a3e] flex items-center justify-center mb-4 text-[#ffc978]" data-id="element-122">
              <Edit3 size={24} data-id="element-123" />
            </div>
            <h3 className="text-white font-bold mb-2" data-id="element-124">Edit Pages</h3>
            <p className="text-[#5a5a7a] text-sm" data-id="element-125">Customize with drag & drop</p>
          </div>

          <div className="flex flex-col items-center" data-id="element-126">
            <div className="w-12 h-12 rounded-full bg-[#1a1a3e] flex items-center justify-center mb-4 text-[#ffc978]" data-id="element-127">
              <Link size={24} data-id="element-128" />
            </div>
            <h3 className="text-white font-bold mb-2" data-id="element-129">Connect Actions</h3>
            <p className="text-[#5a5a7a] text-sm" data-id="element-130">Link steps together</p>
          </div>

          <div className="flex flex-col items-center" data-id="element-131">
            <div className="w-12 h-12 rounded-full bg-[#1a1a3e] flex items-center justify-center mb-4 text-[#ffc978]" data-id="element-132">
              <UploadCloud size={24} data-id="element-133" />
            </div>
            <h3 className="text-white font-bold mb-2" data-id="element-134">Publish</h3>
            <p className="text-[#5a5a7a] text-sm" data-id="element-135">Go live to the world</p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 2.0
      }} data-id="element-136">
          <Button size="lg" onClick={onNext} className="px-12" data-id="element-137">
            Open funnel & continue
          </Button>
        </motion.div>
      </div>

      {/* Back Button - Centered at Bottom */}
      {onBack && <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 2.2
    }} className="flex justify-center pt-8" data-id="element-138">
          <button onClick={onBack} className="flex items-center gap-2 text-[#5a5a7a] hover:text-white text-sm font-medium transition-colors" data-id="element-139">
            <ArrowLeft size={16} data-id="element-140" />
            Back
          </button>
        </motion.div>}
    </div>;
}